export default __webpack_public_path__ + "static/media/horse.42ca919a.svg";